export default "__VITE_ASSET__fXAOJsHO__"